import { ArrowDownWideNarrow, ArrowUpNarrowWide } from 'lucide-react'
import { Explicatie } from './Explicatie'

export type Ordine = 'vechi' | 'noi'

/**
 * Ordinea unei singure liste (o coloana, o banda), direct in capul ei — in locul unui `<select>`
 * comun pentru toata pagina. Nu vrei neaparat sa intorci toate coloanele deodata (Madalin,
 * 14.10.2026). Un clic intoarce ordinea; textul spune ce e sus acum.
 */
export function ButonOrdine({
  ordine,
  laSchimbare,
  ce = 'adăugate',
}: {
  ordine: Ordine
  laSchimbare: (o: Ordine) => void
  /** Dupa ce se ordoneaza, pentru explicatie: „adăugate", „terminate". */
  ce?: string
}) {
  const vechi = ordine === 'vechi'
  const Iconita = vechi ? ArrowUpNarrowWide : ArrowDownWideNarrow
  return (
    <Explicatie
      text={`Sus sunt cele ${vechi ? 'mai vechi' : 'mai recente'}, după data la care au fost ${ce}. Apasă ca să le întorci.`}
      subliniat={false}
      focalizabil={false}
    >
      <button
        type="button"
        onClick={() => laSchimbare(vechi ? 'noi' : 'vechi')}
        aria-label={`Ordine: ${vechi ? 'cele mai vechi sus' : 'cele mai recente sus'}. Apasă ca să întorci.`}
        className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-eticheta font-medium text-b4l-text-muted hover:bg-b4l-bg hover:text-b4l-text"
      >
        <Iconita size={13} aria-hidden="true" />
        {vechi ? 'Vechi' : 'Recente'}
      </button>
    </Explicatie>
  )
}
